import { isVariantOf, ComponentsVariants } from '@/components.variants';
import resolveColorName from '../resolveColorName';
import resolveReference from '../resolveReference';
import resolveRTC from '../resolveRTC';
import resolveString from '../resolveString';
import resolveTabContent from '../resolveTabContent';
import resolveTheme from '../resolveTheme';

export const isTabbedList = isVariantOf(ComponentsVariants.TAB_LIST);

export default (ravVal: any, page: any, pageModels: any, props: any) => {
  const {
    contentList: contentListRef,
    // containerBackgroundColor,
    tabColor,
    // containerTopSpacing,
    template,
    // hasTextShadow,
    textColor,
    // containerBottomSpacing,
  } = props;

  const contentListDoc = resolveReference<any>({ rawVal: contentListRef, page }) || {};
  const { tabGroupTitle, tabGroupDescription, tabContent } = contentListDoc || {};

  const templateMap: any = {
    vertical: 'thumbnail',
    horizontal: 'bottom',
  };
  return {
    variant: ComponentsVariants.TABBED_LIST,
    content: {
      tabGroupTitle,
      tabGroupDescription: resolveRTC({ rawVal: tabGroupDescription }),
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      tabContent: resolveTabContent({ rawVal: tabContent, page, pageModels }),
    },
    tabColor: resolveColorName({ rawVal: tabColor }),
    theme: resolveTheme('text-color')({ rawVal: textColor }),
    template: templateMap[resolveString({ rawVal: template }) || 'vertical'],
  };
};
